// src/pages/PurchasePointCompleted.jsx
import React from 'react';
import { motion } from "framer-motion";
import { useLocation } from 'react-router-dom';
import { jsPDF } from "jspdf";

import PageTitle from '../components/common/pageTitle';
import { slideUp } from '../utils/slideUp';
import '../assets/fonts/NotoSansTC-VariableFont_wght-normal.js';

const PurchasePointCompleted = () => {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const transactionId = queryParams.get('transactionId');
  const email = queryParams.get('email');
  const purchaseVolume = queryParams.get('purchaseVolume');
  const purchaseTime = queryParams.get('purchaseTime');

  const getBase64FromURL = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const downloadPDF = async () => {
    const logoBase64 = await getBase64FromURL('/black-logo.png'); // Adjust the path if necessary
    const doc = new jsPDF();

    doc.addFont("NotoSansTC-VariableFont_wght-normal.ttf", "NotoSansTC", "normal");
    doc.setFont("NotoSansTC"); // Set the font for text rendering

    // Add the logo
    doc.addImage(logoBase64, "PNG", 10, 10, 80, 20); // x, y, width, height

    // Adjust text positioning to be below the logo
    const textStartY = 50; // Start text below the logo

    doc.setFontSize(16);
    doc.text("DraftLegal 點數購買完成", 10, textStartY);
    doc.setFontSize(12);
    doc.text(`交易 ID: ${transactionId}`, 10, textStartY + 10);
    doc.text(`Email: ${email}`, 10, textStartY + 20);
    doc.text(`購買點數: ${purchaseVolume}`, 10, textStartY + 30);
    doc.text(`購買時間: ${purchaseTime.replace(/[-]/g, '/')}`, 10, textStartY + 40);
    doc.text("如有任何問題，請聯絡 admin@bytelingo.co", 10, textStartY + 60);
    doc.text("並提供交易 ID 或用於購買的 Email 與購買時間。", 10, textStartY + 70);

    // Save the PDF
    doc.save(`DrafLegal_purchase_${purchaseTime.replace(/[- :]/g, '')}_${transactionId}.pdf`);
  };

  return (
    <>
      <PageTitle link={"購買完成"} pageName={"購買完成"} />

      <div className="login-area ptb-100">
        <div className="container">
          <motion.div className="login-info"
            initial="offscreen"
            whileInView="onscreen"
            variants={slideUp(1)}
            viewport={{ once: true, amount: 0 }}
          >

            <h1>DraftLegal 點數購買完成</h1>

            <div>

              <div>
                <p>感謝您購買 DraftLegal 平台點數！以下是我們紀錄的資訊：</p>
                <ul>
                  <li><strong>交易 ID：</strong> {transactionId}</li>
                  <li><strong>Email：</strong> {email}</li>
                  <li><strong>購買點數：</strong> {purchaseVolume} </li>
                  <li><strong>購買時間：</strong> {purchaseTime.replace(/[-]/g, '/')} </li>
                </ul>
              </div>

              <hr />

              <div style={{ marginBottom:'30px' }}>
                <p style={{ margin:'0' }}>如果有任何問題，請聯絡 admin@bytelingo.co，並告知我們此筆交易 ID。</p>
                <p style={{ margin:'0' }}>（或者您用於購買的 Email 與購買時間）</p>
              </div>

            </div>

            <div>
              <button 
                className="default-btn border-0" 
                onClick={() => window.location.href = '/dashboard'}
                style={{ marginRight:'15px' }}
              >
                返回主頁
              </button>
              <button 
                className="default-btn border-0" 
                onClick={downloadPDF}
              >
                下載交易資訊（PDF）
              </button>
            </div>

          </motion.div>
        </div>
      </div>
    </>
  );

};

export default PurchasePointCompleted;


